import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ShieldCheck } from "lucide-react";

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="route-loader">
      <div className="flex flex-col items-center gap-4">
        <ShieldCheck className="w-10 h-10 text-gold animate-pulse" />
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-white/50">Securing session</span>
      </div>
    </div>
  );
}

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
